import { createTheme } from '@mui/material';
import { SpotSvg } from '@enterprise/spot';

export const useAppTheme = () => {
    return createTheme({
        shape: {
            borderRadius: 2,
        },
        palette: {
            mode: 'light',
            primary: {
                light: '#0969D9',
                main: '#0969D9',
                dark: '#0969D9',
                contrastText: '#fff',
            },
        },
        components: {
            MuiCheckbox: {
                defaultProps: {
                    className: 'spot-form__checkbox-visual',
                    icon: <></>,
                    checkedIcon: <SpotSvg className="spot-form__checkbox-checked-icon" icon="checkmark" />,
                    indeterminateIcon: <SpotSvg className="spot-form__checkbox-indeterminate-icon" icon="checkbox-indeterminate" />,
                    disableRipple: true,
                },
                styleOverrides: {
                    root: {
                        '&.spot-form__checkbox-visual': {
                            marginRight: 0,
                        },
                        '&>svg': {
                            display: 'unset',
                        },
                    },
                },
            },
        },
    });
};
